var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanWithNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 234,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.17 110.218s-23.552 46.573 2.4 48.977c25.952 2.409 23.539-15.097 23.539-15.097l1.407-17.302-5.514-11.316-21.836-5.262h.004zM155.956 107.306s29.258 45.262 3.811 50.898c-25.447 5.637-25.242-12.031-25.242-12.031l-3.563-16.988 4.055-11.917 20.943-9.958-.004-.004zM121.544 77.234c11.016 0 19.946-8.93 19.946-19.946 0-11.015-8.93-19.945-19.946-19.945-11.015 0-19.945 8.93-19.945 19.945 0 11.016 8.93 19.946 19.945 19.946z",
    fill: "#008AE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.821 83.545c.684 3.41-.549 8.515-5.471 9.53-.523.11-1.194.244-1.978.401-12.632 2.535-18.037 12.053-20.19 24.754l1.983 20.029 1.394 16.77c8.576-.453 9.744-8.455 9.744-8.455l.766 1.442s-3.955 11.979-5.876 18.046c-9.718-3.894-55.001-15.419-62.628 4.269-7.628 19.689 64.545 35.871 64.545 35.871s-14.004 11.046-13.29 24.589c3.677 10.58 44.966-20.464 44.966-20.464s26.523 23.217 36.201 16.417c5.602-3.938-3.262-16.073-3.262-16.073s63.247-14.989 53.085-35c-10.162-20.011-64.641-5.34-64.641-5.34l-8.69-22.319c1.028-8.795.483-4.465.483-4.465s7.266 17.593 22.803 15.759l-.775-23.277-4.23-21.074c-1.899-9.461-8.764-17.11-17.915-20.177-3.598-1.206-6.878-2.748-8.477-4.652-1.145-1.363-1.825-6.834-1.825-6.834l-16.731.248.009.005z",
    fill: "#008AE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.661 226.103c4.861 2.004 9.383 2.722 12.336.649 5.602-3.938-3.263-16.073-3.263-16.073s27.765-6.582 43.546-16.84",
    fill: "#008AE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.661 226.103c4.861 2.004 9.383 2.722 12.336.649 5.602-3.938-3.263-16.073-3.263-16.073s27.765-6.582 43.546-16.84",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.541 223.41c7.248-4.782 19.253-13.076 19.253-13.076s6.586 5.767 14.396 10.711",
    fill: "#008AE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.541 223.41c7.248-4.782 19.253-13.076 19.253-13.076s6.586 5.767 14.396 10.711",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.137 189.581c19.283 9.971 48.977 16.631 48.977 16.631s-14.004 11.046-13.29 24.589c1.473 4.247 9.004 1.79 17.494-2.675",
    fill: "#008AE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.137 189.581c19.283 9.971 48.977 16.631 48.977 16.631s-14.004 11.046-13.29 24.589c1.473 4.247 9.004 1.79 17.494-2.675",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.236 94.652s19.31 10.812 38.62.131l-38.62-.13z",
    fill: "#008AE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.236 94.652s19.31 10.812 38.62.131M94.203 166.066l7.235 3.289M149.177 170.335l-8.585 3.803",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.913 204.562l7.518-6.891a7.774 7.774 0 018.83-1.168l6.939 3.603 5.728-1.364",
    fill: "#008AE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.913 204.562l7.518-6.891a7.774 7.774 0 018.83-1.168l6.939 3.603 5.728-1.364M160.732 210.681l-25.208 3.419",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.347 65.994c0 12.07-10.581 23.33-17.981 23.33-7.401 0-16.949-11.255-16.949-23.33 0-12.074 7.819-21.853 17.467-21.853s17.467 9.783 17.467 21.853h-.004z",
    fill: "#008AE9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.343 70.44c.888-3.998-.893-7.793-3.976-8.478-3.084-.684-6.303 2-7.191 5.998-.887 3.997.893 7.792 3.977 8.477 3.083.685 6.302-2 7.19-5.998z",
    fill: "#008AE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.859 77.233s1.246-2.213 1.791-6.155l-1.791 6.155z",
    fill: "#008AE9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.859 77.233s1.246-2.213 1.791-6.155",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.346 68.418s.962-4.395 3.885-2.422l-3.885 2.422z",
    fill: "#008AE9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.346 68.418s.962-4.395 3.885-2.422",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.161 73.135s3.472-3.328 1.128-7.562l-1.128 7.562z",
    fill: "#008AE9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.161 73.135s3.472-3.328 1.128-7.562",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.578 76.437c3.083-.685 4.864-4.48 3.976-8.477-.888-3.997-4.107-6.682-7.19-5.998-3.084.685-4.864 4.48-3.977 8.477.888 3.998 4.107 6.683 7.191 5.998z",
    fill: "#008AE9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.877 77.233s-1.246-2.213-1.79-6.155l1.79 6.155z",
    fill: "#008AE9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.877 77.233s-1.246-2.213-1.79-6.155",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.39 68.418s-.962-4.395-3.885-2.422l3.885 2.422z",
    fill: "#008AE9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.39 68.418s-.962-4.395-3.885-2.422",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.576 73.135s-3.471-3.328-1.128-7.562l1.128 7.562z",
    fill: "#008AE9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.576 73.135s-3.471-3.328-1.128-7.562",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110 82.013s3.925 7.309 11.36 7.309c5.619 0 10.175-5.118 10.175-5.118",
    fill: "#008AE9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110 82.013s3.925 7.309 11.36 7.309c5.619 0 10.175-5.118 10.175-5.118",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.832 47.682c5.711 0 10.341-4.63 10.341-10.341 0-5.711-4.63-10.341-10.341-10.341-5.711 0-10.341 4.63-10.341 10.34 0 5.712 4.63 10.342 10.341 10.342zM137.757 64.984c-17.035.248-22.733-12.305-22.733-12.305s-2.936 9.13-9.439 12.427",
    fill: "#008AE9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.757 64.984c-17.035.248-22.733-12.305-22.733-12.305s-2.936 9.13-9.439 12.427",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 37.342s11.138-1.46 17.372 7.583l-17.372-7.583z",
    fill: "#008AE9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 37.342s11.138-1.46 17.372 7.583",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.41 116.422l2.535 1.041 5.314 30.556",
    fill: "#008AE9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94.41 116.422l2.535 1.041 5.314 30.556",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.324 117.569l-2.535 1.041-5.114 29.411",
    fill: "#008AE9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.324 117.569l-2.535 1.041-5.114 29.411",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M89.336 129.64h71.158a3.627 3.627 0 013.624 3.624v47.165h-78.41v-47.165c0-2 1.625-3.624 3.624-3.624h.004z",
    fill: "#35B3A9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M131.58 155.286c0-1.84-1.366-3.334-3.054-3.334a3.176 3.176 0 00-1.736.601c-.5.364-.87.865-1.06 1.436a.088.088 0 01-.035.034.089.089 0 01-.048.013.094.094 0 01-.082-.047 2.922 2.922 0 00-1.06-1.436 3.176 3.176 0 00-1.736-.601c-1.688 0-3.054 1.494-3.054 3.334a3.321 3.321 0 00.31 1.491c.217.47.541.888.949 1.224l4.591 4.298c.01.012.023.021.037.027.014.006.03.01.045.01a.119.119 0 00.046-.01.098.098 0 00.037-.027l4.591-4.298c.406-.337.73-.755.947-1.225.218-.469.324-.978.312-1.49v0z",
    stroke: "#333"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M85.714 163.394v6.943",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M119.581 129.64H87.23c-.837 0-1.516.679-1.516 1.515v26.528",
    fill: "#35B3A9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M119.581 129.64H87.23c-.837 0-1.516.679-1.516 1.515v26.528",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M164.124 156.254v-25.099c0-.836-.68-1.515-1.516-1.515h-31.149",
    fill: "#35B3A9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M164.124 156.254v-25.099c0-.836-.68-1.515-1.516-1.515h-31.149M164.122 176.666v-9.465",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.541 180.428h45.824",
    fill: "#008AE9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M108.541 180.428h45.824",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M54.224 165.496s26.052-.976 67.89 22.302l-3.528 10.232",
    fill: "#008AE9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.224 165.496s26.052-.976 67.89 22.302l-3.528 10.232",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M130.965 209.737l-6.046-17.946s26.806-12.916 67.577-20.469",
    fill: "#008AE9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.965 209.737l-6.046-17.946s26.806-12.916 67.577-20.469",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.531 66.73s4.143-6.23 9.396-3.393c6.351 3.432.496 14.243.496 14.243l3.455 1.847",
    fill: "#008AE9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M108.531 66.73s4.143-6.23 9.396-3.393c6.351 3.432.496 14.243.496 14.243l3.455 1.847",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M110.873 70.553s3.145 2.378 6.922 0h-6.922z",
    fill: "#008AE9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110.873 70.553s3.145 2.378 6.922 0",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M125.006 70.553s3.145 2.378 6.921 0h-6.921z",
    fill: "#008AE9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M125.006 70.553s3.145 2.378 6.921 0",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 82.013s2.714 3.297 6.743 0h-6.743z",
    fill: "#008AE9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M118.172 82.013s2.714 3.297 6.743 0M158.542 37.5c-.419-.048-.453-.65-.041-.738a16.42 16.42 0 0012.778-14.252c.047-.419.649-.453.737-.04a16.42 16.42 0 0014.252 12.778c.419.047.453.649.04.737a16.422 16.422 0 00-12.778 14.251c-.047.42-.649.453-.737.041a16.42 16.42 0 00-14.251-12.778zM178.283 10.198c-.25-.027-.27-.386-.027-.447a9.858 9.858 0 007.667-8.552c.027-.25.385-.27.446-.027a9.858 9.858 0 008.552 7.667c.25.027.271.385.027.446a9.856 9.856 0 00-7.666 8.552c-.027.25-.386.27-.447.027a9.857 9.857 0 00-8.552-7.666zM215.408 109.92c-.25-.027-.27-.385-.027-.446a9.859 9.859 0 007.667-8.552c.027-.25.385-.271.446-.027a9.856 9.856 0 008.552 7.666c.25.027.271.386.027.447a9.855 9.855 0 00-7.666 8.552c-.027.25-.386.27-.447.027a9.857 9.857 0 00-8.552-7.667zM1.199 217.584c-.25-.027-.27-.385-.027-.446a9.858 9.858 0 007.667-8.552c.027-.25.385-.271.446-.027a9.856 9.856 0 008.552 7.666c.25.027.27.386.027.447a9.857 9.857 0 00-7.666 8.552c-.027.25-.386.27-.447.027a9.858 9.858 0 00-8.552-7.667z",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/womanWithNote.fca7d01f.svg";
export { SvgWomanWithNote as ReactComponent };